<template>
  <div>
    <!-- 插件信息列表 -->
    <el-table :data="list.value" :span-method="objectSpanMethod" border style="width: 100%; margin-top: 20px"
      empty-text="-">
      <el-table-column width="200" prop="code" label="插件ID"></el-table-column>
      <el-table-column prop="name" label="插件名称"></el-table-column>
      <el-table-column prop="descr" label="更新说明"></el-table-column>
      <el-table-column prop="ver" label="插件版本"></el-table-column>
      <el-table-column show-overflow-tooltip prop="fileMd5" label="md5"></el-table-column>
      <el-table-column prop="appVer" label="支持APP版本"></el-table-column>
      <el-table-column prop="sdkVer" label="支持SDK版本"></el-table-column>
      <el-table-column width="200" prop="createUser" label="上传人/时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createUser }}</span>&nbsp;<span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button v-auth="'PLUGIN_MANAGE_PLUGIN_CONFIG_DEL'" type="text" size="small"
            @click="del(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <ElementPagination style="margin-bottom: 20px" :total="searchParams.total" :current="searchParams.current"
      :size="searchParams.size" :pageSizes="[10, 20, 50, 100]" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" />
  </div>
</template>

<script>
import { deletePlugins } from "@/api/pluginManage/pluginConfig";
import ElementPagination from "@/components/ElementPagination";
import Message from "@/components/Message";
export default {
  name: "WebSaaSTable",
  inject: ["searchParams", "list", "loadList"],
  components: {
    ElementPagination,
  },
  data() {
    return {};
  },
  methods: {
    objectSpanMethod({ row, _, rowIndex, columnIndex }) {
      // 合并“插件ID”和“插件名称”列
      if (columnIndex === 0 || columnIndex === 1) {
        // 第一列和第二列都要合并
        const currentCode = row.code;

        // 如果当前行的插件ID与上一行相同，则隐藏当前行的单元格
        if (rowIndex > 0 && this.list.value[rowIndex - 1].code === currentCode) {
          return { rowspan: 0, colspan: 0 };
        }

        // 否则，计算当前插件ID的连续行数，并返回合并行数
        let rowspan = 1;
        for (let i = rowIndex + 1; i < this.list.value.length; i++) {
          if (this.list.value[i].code === currentCode) {
            rowspan++;
          } else {
            break;
          }
        }

        return { rowspan, colspan: 1 };
      }

      // 非“插件ID”和“插件名称”列不进行合并
      return { rowspan: 1, colspan: 1 };
    },
    /** 删除 */
    del(id) {
      this.$confirm("此操作将永久删除该插件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const { data } = await deletePlugins(id);
          if (data.code === 200) {
            Message.success("删除成功");
            this.loadList();
          }
        })
        .catch(() => {
          console.log("取消删除");
        });
    },
    //^ ^--------------分页相关-------------^ ^
    /** 每页条数change */
    handleSizeChange(val) {
      this.searchParams.size = val;
      Message.success(`每页 ${val} 条`);
      /** 更新数据 */
      this.loadList();
    },
    /** 当前页change */
    handleCurrentChange(val) {
      this.searchParams.current = val;
      Message.success(`当前页 ${val}`);
      /** 更新数据 */
      this.loadList();
    },
  },
};
</script>

<style lang="scss" scoped>
.el-tooltip__popper {
  max-width: 80% !important;
}
</style>
